import type {
  BodyAwarenessSensitivityId,
  EarlySignId,
  EnvironmentalSensitivityId,
  LightSensitivityId,
  MovementSensitivityId,
  SmellSensitivityId,
  SoundSensitivityId,
  TasteSensitivityId,
  TouchSensitivityId,
  WhatHelpsId,
} from "@/lib/sensory-profile/options";
import type { SensitivityRatings } from "@/lib/sensory-profile/schema";
import { SENSORY_DOMAINS } from "@/lib/sensory-profile/options";

function zeroRatings(): SensitivityRatings {
  return Object.fromEntries(
    SENSORY_DOMAINS.map((domain) => [domain.id, 0]),
  ) as SensitivityRatings;
}

export const defaultSensoryProfileValues = {
  firstName: "",
  lastName: "",
  dateOfBirth: undefined as Date | undefined,
  childNickname: "",
  childDateOfBirth: undefined as Date | undefined,
  email: "",
  phone: "",
  privacyAgreed: false as boolean,
  selectedSounds: [] as SoundSensitivityId[],
  additionalSounds: "",
  selectedLightsAndVisualInput: [] as LightSensitivityId[],
  additionalLightsAndVisualInput: "",
  selectedTouchAndTextures: [] as TouchSensitivityId[],
  additionalTouchAndTextures: "",
  selectedSmells: [] as SmellSensitivityId[],
  additionalSmells: "",
  selectedTastes: [] as TasteSensitivityId[],
  additionalTastes: "",
  selectedMovement: [] as MovementSensitivityId[],
  additionalMovement: "",
  selectedBodyAwareness: [] as BodyAwarenessSensitivityId[],
  additionalBodyAwareness: "",
  selectedEnvironmental: [] as EnvironmentalSensitivityId[],
  additionalEnvironmental: "",
  sensitivityRatings: zeroRatings(),
  selectedEarlySigns: [] as EarlySignId[],
  additionalEarlySigns: "",
  selectedWhatHelps: [] as WhatHelpsId[],
  additionalWhatHelps: "",
  triggerOne: "",
  triggerTwo: "",
  triggerThree: "",
  earliestSigns: "",
  whatUsuallyHelps: "",
  overloadPlan: "",
};

export type SensoryProfileFormValues = typeof defaultSensoryProfileValues;
